import { render, staticRenderFns } from "./c-btn.vue?vue&type=template&id=c62e2c36"
import script from "./c-btn.vue?vue&type=script&lang=js"
export * from "./c-btn.vue?vue&type=script&lang=js"
import style0 from "./c-btn.vue?vue&type=style&index=0&id=c62e2c36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CLoader: require('/app/components/ui/c-loader.vue').default})
